import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { initGTM } from './gtm'; // GTM初期化関数をインポート

// アプリの起動前にGTMを初期化関数の呼び出し
initGTM();

// ローカル開発時（local環境 / localhost起動）はSentryへ通知させない
const isLocalEnv = process.env.REACT_APP_ENV === 'local';
const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);

// Sentryを最初に初期化（アプリケーション起動前）。ローカル時は初期化自体をスキップ
if (!isLocalEnv && !isLocalhost) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // 開発環境でのデバッグ用
      if (process.env.REACT_APP_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('[Sentry] Sending event:', event);
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
